import React from 'react';
import { observer } from 'mobx-react';

import { Intro } from '../Intro/Intro';
import bg1 from '../../assets/images/bg1.png';
import bg2 from '../../assets/images/bg2.png';
import bg3 from '../../assets/images/bg3.png';
import bg4 from '../../assets/images/bg4.png';
import blur from '../../assets/images/blur.png';
import Image from '../../components/UI/Image/Image';

import classes from './main.module.scss';

import { useStorage } from '@/models/Storage';
import { Quiz } from '@/screens/Quiz/Quiz';
import { Outro } from '@/screens/Outro/Outro';

export const Main = observer(() => {
    const { stage } = useStorage();

    return (
        <section id={'main'} className={`${classes.main} ${classes[stage]}`}>
            <div className={classes.blur1} />
            <Image src={blur} className={classes.blur1} />
            <Image src={blur} className={classes.blur2} />
            <div className={`${classes.bg1} ${classes.desktop}`}>
                <Image className={'anim-levitate'} src={bg1} />
            </div>
            <div className={`${classes.bg3} ${classes.desktop}`}>
                <Image src={bg3} className={`anim-levitate`} />
            </div>
            <Intro />
            <Quiz />
            <Outro />
            <div className={`${classes.bg2} ${classes.desktop}`}>
                <Image className={'anim-levitate'} src={bg2} />
            </div>
            <div className={`${classes.bg4} ${classes.desktop}`}>
                <Image src={bg4} className={`anim-levitate`} />
            </div>
            <span className={classes.achtung}>Наш проект со звуком</span>
        </section>
    );
});
